import React, { Fragment, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Splitter } from "@progress/kendo-react-layout";
import { PanelBar, PanelBarItem } from "@progress/kendo-react-layout";
import { Checkbox } from "@progress/kendo-react-inputs";
import {
  Toolbar,
  ToolbarItem,
  ToolbarSeparator,
  ToolbarSpacer,
  Button,
  DropDownButton,
} from "@progress/kendo-react-buttons";
import { Loader } from "@progress/kendo-react-indicators";
import { DropDownListById } from "../../forms/form-components";
import { Form } from "../../components/form";
import { List } from "../../components/list";
import { Input } from "@progress/kendo-react-inputs";
import { DataCorrectionPageForm } from "./datacorrectionpageform";
import { getDataSourceIcon } from "../../lib/utils";
import { IntroPage } from "../intropage";
import { HelpPage } from "../helppage";
import { ReactComponent as TableIcon } from "../../icons/table.svg";
import { ReactComponent as DatabaseIcon } from "../../icons/database.svg";
import { ReactComponent as AggregateIcon } from "../../icons/aggregate.svg";
import { ReactComponent as LockIcon } from "../../icons/folderlock.svg";
import { ReactComponent as GroupIcon } from "../../icons/layergroup.svg";
import { ReactComponent as ValueTableIcon } from "../../icons/dialpad.svg";
import { ReactComponent as ValueIcon } from "../../icons/desktop.svg";
import { ReactComponent as CompleteIcon } from "../../icons/ellipsish.svg";
import {
  canDeleteData,
  canDeleteDataResolved,
  canEditData,
  canEditDataResolved,
  canViewDataResolved
} from "../../routing/authorizationhandlers";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const datasetItemRender = (li, itemProps) => {
  let itemIcon = "";

  if (itemProps.dataItem.CategoryId == 1)
    //table
    itemIcon = "grid";
  else if (itemProps.dataItem.CategoryId == 2)
    //view
    itemIcon = "group";
  else if (itemProps.dataItem.CategoryId == 3)
    //SP
    itemIcon = "html";
  //"none"
  else itemIcon = "minus";

  const itemChildren = (
    <div
      className="datasets-list-item"
      style={{ display: "flex", alignItems: "center", padding: "0px 6px" }}
    >
      <div
        style={{
          marginRight: 12,
        }}
        className={`k-icon k-i-${itemIcon}`}
      ></div>
      <div>{itemProps.dataItem.Title}</div>
    </div>
  );

  return React.cloneElement(li, li.props, itemChildren);
};

const toolbarRenderer = (props) => {
  const { currentTheme, currentUser, pageState, t } = props;

  return (
    <Toolbar>
      {currentUser.IsAuthenticated && canEditData(currentUser) && (
        <Fragment>
          <ToolbarItem>
            <Button
              style={{ color: currentTheme.primary }}
              icon="edit"
              onClick={props.onModifyData}
            >
              {t("datacorrection.modifydata")}
            </Button>
          </ToolbarItem>
        </Fragment>
      )}
      {currentUser.IsAuthenticated && canDeleteData(currentUser) && (
        <Fragment>
          <ToolbarSeparator />
          <ToolbarItem>
            <Button
              disabled={pageState.processing}
              style={{ color: currentTheme.primary }}
              icon="delete"
              onClick={(e) => props.onDelete()}
            >
              {t("datacorrection.deletedata")}
            </Button>
          </ToolbarItem>
        </Fragment>
      )}
    </Toolbar>
  );
};

const getEntityOperations = (expression, currentUser, t) => {
  let result = [];

  if (expression.IsSystem) {
    if (
      currentUser.IsAuthenticated &&
      (canViewDataResolved(currentUser) || canEditDataResolved(currentUser))
    )
      result.push({ id: 1, text: t("datacorrection.view"), icon: "eye" });
  } else {
    if (
      currentUser.IsAuthenticated &&
      (canViewDataResolved(currentUser) || canEditDataResolved(currentUser))
    )
      result.push({ id: 2, text: t("datacorrection.view"), icon: "eye" });

    if (currentUser.IsAuthenticated && canDeleteDataResolved(currentUser))
      result.push({ id: 3, text: t("datacorrection.delete"), icon: "delete" });
  }

  return result;
};

const entityMenuItemRenderer =
  (currentTheme, entityId, onItemClicked) => (props) => {
    if (props.item.text)
      return (
        <div
          style={{ display: "flex", width: "100%", padding: "0px 6px" }}
          onClick={(e) => onItemClicked(entityId, props.item)}
        >
          <span
            className={`k-icon k-i-${props.item.icon}`}
            style={{ display: "inline-block" }}
          ></span>
          <div style={{ marginLeft: 12 }}>{props.item.text}</div>
        </div>
      );
    else return <div className="menu-separator" style={{}} />;
  };

const entitiesItemRenderer =
  (currentTheme, currentUser, t) => (props, item, index) => {
    const icon = getDataSourceIcon(item.TypeId);

    return (
      <div
        key={item.Id}
        className={`list-item`}
        onDoubleClick={(e) => {
          if (
            currentUser.IsAuthenticated &&
            (canViewDataResolved(currentUser) || canEditDataResolved(currentUser))
          )
            props.onEntityDoubleClick(item.Id);
        }}
      >
        <div className={`list-item-datasource-icon k-icon ${icon}`}></div>
        <div className="list-item-title">{item.Title}</div>
        {currentUser.IsAuthenticated &&
          (canViewDataResolved(currentUser) ||
            canEditDataResolved(currentUser) ||
            canDeleteDataResolved(currentUser)) && (
            <div className="list-item-operations">
              <DropDownButton
                className="buttons-container-button"
                items={getEntityOperations(item, currentUser, t)}
                itemRender={entityMenuItemRenderer(
                  currentTheme,
                  item.Id,
                  (entityId, _item) => {
                    if (_item.id == 1 || _item.id == 2)
                      //view
                      props.onEntitySelected(entityId, _item);
                    else if (_item.id == 3)
                      // delete
                      props.onDelete(entityId, _item);
                  }
                )}
                icon="more-horizontal"
                fillMode={"flat"}
              />
            </div>
          )}
      </div>
    );
  };

export const DataCorrectionPageBody = (props) => {
  const {
    onSplitterChange,
    dataSetsPanelRef,
    onDatasetChange,
    //onNew, onSave,
    onModifyData,
    onDelete,
    //onErrorbarClose,
    onEntitySelected,
    onEntityDoubleClick,
    onAddFieldToUpdate,
    onNewValueChange,
    updateDirtyState,
    onGroupedFieldCheck,
    onGroupedFieldsCheck,
    onLoadDataGrid,
    onToggleEquation,
    onOperatorChange,
    onFieldToUseChange,
    onKeyChange,
    ...other
  } = props;

  const currentTheme = useSelector((state) => state.currentTheme);
  const currentUser = useSelector((state) => state.currentUser);
  const appearance = useSelector((state => state.appearance));
  const pageState = useSelector((state) => state.dataCorrectionPage);
  const datasets = pageState.lookups.datasets;
  const currentDataset = pageState.currentDataset;
  const currentDatasetId = currentDataset.Id;
  const { t } = useTranslation();

  const getPanelBarItems = () => {
    const panelBarItems = [];

    panelBarItems.push(
      <PanelBarItem
        className="panel-dataset"
        key="dataset"
        title={t("datacorrection.dataset")}
        expanded={true}
      >
        <div className="dataset">
          <DropDownListById
            iconClassName="k-icon k-i-arrow-s k-i-table"
            style={{ marginTop: 4 }}
            data={datasets}
            dataItemKey="Id"
            textField="Title"
            value={currentDatasetId}
            onChange={onDatasetChange}
            itemRender={datasetItemRender}
          />
          {currentDatasetId == 0 && (
            <div
              style={{ marginLeft: 3, color: `${currentTheme.touchColor}` }}
              className="k-form-hint k-text-center"
            >
              {t("datacorrection.select")}
            </div>
          )}
        </div>
      </PanelBarItem>
    );

    if (currentDataset.Id > 0) {
      panelBarItems.push(
        <PanelBarItem
          className="panel-description"
          key="help"
          title={t("datacorrection.description")}
          selected={false}
          expanded={false}
          style={{}}
        >
          <p className="description" style={{ padding: "6px 12px", margin: 0 }}>
            {currentDataset.Description}
          </p>
        </PanelBarItem>
      );
    }

    return panelBarItems;
  };

  return (
    <Fragment>
      {pageState.processing && (
        <div className="page-loader">
          <Loader
            size={"large"}
            type="infinite-spinner"
            themeColor={"primary"}
          />
          {pageState.processingText && (
            <div style={{ fontSize: 13, color: currentTheme.primary }}>
              {pageState.processingText}
            </div>
          )}
        </div>
      )}
      {pageState.pageLoaded && (
        <Splitter
          style={{ border: "none" }}
          panes={pageState.panes}
          onChange={onSplitterChange}
        >
          <div className="datacorrection-page-manager">
            <PanelBar
              ref={dataSetsPanelRef}
              style={{ border: "none" }}
              expanded={[".0", ".1"]}
            >
              {getPanelBarItems()}
            </PanelBar>
          </div>
          {currentDatasetId > 0 && (
            <Form
              className="datacorrection-page-form"
              currentTheme={currentTheme}
              currentUser={currentUser}
              toolbarRenderer={toolbarRenderer}
              t = { t } //onNew={onNew} onSave={onSave}
              onModifyData={onModifyData}
              onDelete={onDelete}
              errorMessages={pageState.formServerErrors} //onErrorbarClose={onErrorbarClose}
              pageState={pageState}
            >
              <DataCorrectionPageForm
                //onAddFieldToUpdate={onAddFieldToUpdate}
                onNewValueChange={onNewValueChange}
                onGroupedFieldCheck={onGroupedFieldCheck}
                onGroupedFieldsCheck={onGroupedFieldsCheck}
                onLoadDataGrid={onLoadDataGrid}
                onToggleEquation={onToggleEquation}
                onOperatorChange={onOperatorChange}
                onFieldToUseChange={onFieldToUseChange}
                updateDirtyState={updateDirtyState}
                onFieldRemove={props.onFieldRemove}
                onOpenFieldsDialog={props.onOpenFieldsDialog}
                onCloseFieldsDialog={props.onCloseFieldsDialog}
                onFieldCheck={props.onFieldCheck}
                onSaveFieldsDialog={props.onSaveFieldsDialog}
                onFieldDragStart={props.onFieldDragStart}
                onFieldDragOver={props.onFieldDragOver}
                onFieldDrop={props.onFieldDrop}
                onFieldsClear={props.onFieldsClear}
                onFieldTitleChange={props.onFieldTitleChange}
                onFieldSortDirectionChange={props.onFieldSortDirectionChange}
                onKeyChange={onKeyChange}
              />
            </Form>
          )}
          {currentDatasetId <= 0 && <Fragment></Fragment>}
        </Splitter>
      )}
      <style>
        {`
                   .datacorrection-page > .content
                   {
                   } 

                    .datacorrection-page .k-splitter{
                      flex-direction:${
                        appearance.isRightToLeft ? "row-reverse" : "row"
                      } 
                    }
                      
                    .datacorrection-page .k-splitter .k-pane{
                      direction:${appearance.isRightToLeft ? "rtl" : "ltr"} 
                    }

                    .datacorrection-page .datasetview-page-wrapper{
                    border: ${currentTheme.pageFormBorder};   
                    height:100%; direction:${
                      appearance.isRightToLeft ? "rtl" : "ltr"
                    } 
                    
                    }  
                   
                    /*the manager*/
                    .datacorrection-page > .content .datacorrection-page-manager
                    {
                      border: ${currentTheme.managerBorder};
                      border-radius: ${currentTheme.pageBorderRadius};
                      background-color: ${currentTheme.componentBgFaded};
                    }

                    .datacorrection-page > .content .datacorrection-page-manager .k-dropdownlist
                    {
                      /*bg of datasets dropdown*/
                      background-color: transparent;
                      color: ${currentTheme.componentText};
                    }

                    .datacorrection-page > .content .datacorrection-page-manager .k-dropdownlist:focus
                    {
                        box-shadow: none;   
                    }

                    .datacorrection-page > .content .datacorrection-page-manager .panel-entities .k-input::placeholder
                    {
                        color: ${currentTheme.componentText};
                        /*font-style: italic;*/
                    }

                    .datacorrection-page > .content .datacorrection-page-manager .k-panelbar
                    {
                      background-color: transparent;
                    }

                    .datacorrection-page > .content .expressions-page-manager ul li.k-panelbar-header.k-panelbar-item .k-link .k-icon
                    {
                      /*the arrow near every panel header*/
                      color: ${currentTheme.touchColor}!important;
                      margin-right: 6px;
                    }

                    .datacorrection-page > .content .datacorrection-page-manager ul li.k-panelbar-header.k-panelbar-item .k-link
                    {
                      /*the span in the above <li> i.e. the title of every group in the manager: datasets, datacorrection, columns and description*/  
                      background-color: transparent;
                      color: ${currentTheme.touchColor};
                      border-bottom: 1px solid ${currentTheme.separatorColor}; 
                    }

                    .datacorrection-page > .content .datacorrection-page-manager ul li.k-panelbar-header.k-panelbar-item .k-link:hover
                    {
                      /*the above hovered - do nothing*/
                    }

                    .datacorrection-page > .content .datacorrection-page-manager .datacorrection .list-item:hover
                    {
                      /*expression item hover */
                      background-color: ${currentTheme.componentBorderColor};
                      cursor: pointer;
                    }

                    .datacorrection-page > .content .datacorrection-page-manager .dataset,
                    .datacorrection-page > .content .datacorrection-page-manager .description,
                    .datacorrection-page > .content .datacorrection-page-manager .k-child-animation-container
                    {
                      /*bg color of exp. manager elements */
                    }

                    .datacorrection-page > .content .datacorrection-page-manager .list-container
                    {
                      /*bg of both the exp. and columns Lists*/
                      background-color: transparent;
                      padding: 0;
                    }

                    .datacorrection-page > .content .datacorrection-page-manager .k-panelbar-header
                    {
                      background-color: transparent;
                    }

                    .datacorrection-page > .content .datacorrection-page-manager .k-panelbar-content
                    {
                      background-color: transparent;
                    }

                    .datacorrection-page > .content .datacorrection-page-manager .datacorrection .list-item-datasource-icon
                    {
                      /*first icon in datacorrection list*/
                      padding-left: 12px!important;
                    }

                    .datacorrection-page > .content .datacorrection-page-manager .datacorrection .list-item-datasource-icon
                    {
                      /*second icon in data sources list*/
                      padding: 5px 3px;                 
                    }

                    .datacorrection-page > .content .datacorrection-page-manager .datacorrection .list-item-title
                    {
                      vertical-align: middle;/*fine tuning*/
                    }               


                    /*the form*/
                    .datacorrection-page-form
                    {
                      background-color: transparent;
                      padding-left: 0px;
                      border: ${currentTheme.pageFormBorder};   
                      border-radius: ${currentTheme.pageBorderRadius};
                    }   

                    /*form toolbar*/
                    .datacorrection-page-form > .toolbar .k-toolbar
                    {
                        width: 100%;
                        border-left: none !important;
                        border-bottom: 1px solid ${currentTheme.separatorColor};
                        border-top: none !important;
                        border-right: none !important;
                        background-color: ${currentTheme.toolbarBg};/*transparent;*/
                    }                    

                    .datacorrection-page > .content .toolbar .k-button
                    {
                      /*the toolbar buttons*/
                      border: none;
                      padding: 6px 8px;
                    }

                    .datacorrection-page > .content .toolbar .k-button-text
                    {
                      /*color of the text in every toolbar button=black in azure theme*/
                      color: ${currentTheme.toolbarText};
                    }

                    .datacorrection-page > .content .toolbar .k-button-icon
                    {
                      font-weight: 500;
                      color: ${currentTheme.primary};
                    }

                    .datacorrection-page > .content .form-root .content
                    {
                      background-color: ${currentTheme.pageContentBg};
                    }

                    /*styling the popup menu */
                    .k-popup ul{
                        padding: 0px;
                    }

                    .k-popup ul > li{
                        margin: 0;
                        padding: 0px;                                
                    }

                    .k-popup ul > li > span{
                        border: none !important;
                        box-shadow: none !important;
                    }

                    .k-menu-link{
                        padding: 0px 0px !important;                        
                    }
                  `}
      </style>
    </Fragment>
  );
};
